import { Component, OnInit } from '@angular/core';
import { CompanyService } from '../../services/company.service';
import { UserService } from '../../../auth-client/services/user.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ShoppingService } from '../../services/shopping.service';
import { Router } from '@angular/router';
import { FilterService } from '../../services/filter.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'brover-place-order',
    templateUrl: './place-order.component.html',
    standalone: false
})
export class PlaceOrderComponent implements OnInit {

  constructor(public companyService: CompanyService, private router: Router, public userService: UserService,
              public shoppingService: ShoppingService, public filterService: FilterService) {
  }

  resourceUrl = environment.resource_api;
  brands: any[] = [];
  startDate = new Date();
  private avaliableDays = [];
  myFilter = ((d: Date): boolean => {
    const day = d.getDay();
    return this.avaliableDays.indexOf(day) !== -1;
  });

  ngOnInit() {
    if (this.shoppingService.order.shoppingBag.length > 0) {
      this.router.navigate(['/', 'dashboard', 'place-order', 'overview', 'ordered', false]);
    }

    if (this.filterService.brand !== null && this.filterService.type !== null) {
      this.router.navigate(['/', 'dashboard', 'place-order', 'configuration']);
    }

    this.companyService.getBrands().subscribe(types => {
      if (types['data']) {
        this.brands = types['data']['cars'];
      }
    });
  }

  getBrands() {
    const brands = [];
    if (this.brands) {
      this.brands.forEach(brand => {
        if (brands.findIndex(x => x.name === brand.name) === -1) {
          brands.push(brand);
        }
      });
    }
    return brands;
  }

  getType() {
    const brand = this.brands.find(x => x.name === this.filterService.brand.name);
    if (!brand) {
      return [];
    }

    return brand.types;
  }

  dateChange(event: MatDatepickerInputEvent<any & Date>) {
    this.shoppingService.order.deliverDate = event.value;
  }
}
